import PropTypes from "prop-types";
import { Form, Row, Col } from "react-bootstrap";
import moment from "moment";

import "./dateRadios.css";

const DateRadios = ({ dateRange, setDateRange, setStartDate, setEndDate }) => {
  const handleChange = (e) => {
    const str = e.target.value;
    setDateRange(str);

    switch (str) {
      case "This Month":
        setStartDate(moment().startOf("month").format());
        setEndDate(moment().endOf("month").format());
        break;

      case "Last Month":
        setStartDate(moment().subtract(1, "months").startOf("month").format());
        setEndDate(moment().subtract(1, "months").endOf("month").format());
        break;

      case "Current Fiscal Year":
        if (moment().month() < 9) {
          setStartDate(moment().startOf("year").subtract(3, "months").format());
          setEndDate(
            moment()
              .startOf("year")
              .add(9, "months")
              .subtract(1, "days")
              .format()
          );
        } else {
          setStartDate(
            moment().endOf("year").subtract(3, "months").add(1, "days").format()
          );
          setEndDate(moment().endOf("year").add(9, "months").format());
        }
        break;

      case "Last Fiscal Year":
        if (moment().month() < 9) {
          setStartDate(
            moment()
              .startOf("year")
              .subtract(3, "months")
              .subtract(1, "years")
              .format()
          );
          setEndDate(
            moment()
              .startOf("year")
              .add(9, "months")
              .subtract(1, "days")
              .subtract(1, "years")
              .format()
          );
        } else {
          setStartDate(moment().startOf("year").subtract(3, "months").format());
          setEndDate(
            moment()
              .startOf("year")
              .add(9, "months")
              .subtract(1, "days")
              .format()
          );
        }
        break;

      default:
    }
  };

  const values = [
    "Custom",
    "This Month",
    "Last Month",
    "Current Fiscal Year",
    "Last Fiscal Year",
  ];

  const radiosContainer = (
    <Form>
      <Row className="justify-content-center">
        <Col xs={9} className="text-center">
          <div>
            {values.map((value, index) => (
              <Form.Check
                key={index}
                inline
                label={value}
                name="date-range"
                type="radio"
                id={`date-range-${index + 1}`}
                value={value}
                onChange={handleChange}
                checked={dateRange === value}
              />
            ))}
          </div>
        </Col>
      </Row>
    </Form>
  );

  return <div>{radiosContainer}</div>;
};

DateRadios.propTypes = {
  dateRange: PropTypes.string.isRequired,
  setDateRange: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
};

export default DateRadios;
